const word = "_35sw1fo62k8";
const char = "_35sc1mhy3is";
const readonlyHyphen = "_35sr1mrmbus";
const stateBox = "_35ss1nr97hw";

export { char, readonlyHyphen, stateBox, word };
import "./atom.facit.word.style.linaria.module.css";
//# sourceMappingURL=atom.facit.word.style.js.map
